import { useLocales } from '@shared/locales'
import { Form, Input } from 'antd'

export const FormNomenclaturesSubIndustries = () => {
  const { t } = useLocales()

  return (
    <Form.Item
      name="name"
      label={t('nomenclature.name')}
      rules={[{ required: true }]}
    >
      <Input />
    </Form.Item>
  )
}
